import React from "react";
import ProgressBar from "react-scroll-progress-bar";

import "./App.css";
import Home from "./components/Home/Home";
import Content from "./components/Content/Content";

function App() {
  return (
    <div className="App">
      <ProgressBar bgcolor="#3b82f6" height={3} />
      <Home />
      <Content />
    </div>
  );
}

export default App;
